export default __webpack_public_path__ + "static/media/flag-djibouti.a2ededba.svg";